import { GetPatientDetailsSchema } from '@montugroup/pms-api-contracts';
import { z } from 'zod';

const state = z.object({
  state: z
    .union([
      z.object({
        id: z.number(),
        label: z.string()
      }),
      z.number()
    ])
    .nullable()
    .refine((val) => val !== null, {
      message: 'State is required.'
    })
});

const streetLine1 = z.object({
  streetLine1: z
    .string()
    .trim()
    .nullable()
    .refine((val) => val !== null && val !== '', {
      message: 'Street address is required.'
    })
});

const streetLine2 = z.object({
  streetLine2: z.string().trim().nullable().optional()
});
export const schema = GetPatientDetailsSchema.shape.basicInfo
  .unwrap()
  .shape.attributes.shape.residentialAddress.unwrap()
  .pick({
    city: true,
    zipCode: true
  })
  .merge(state)
  .merge(streetLine1)
  .merge(streetLine2)
  .refine(
    (data) => {
      return data.city !== null && data.city !== '';
    },
    {
      message: 'Suburb is required',
      path: ['city']
    }
  )
  .refine(
    (data) => {
      return data.state !== null && data.state !== 0;
    },
    { message: 'State is required.', path: ['state'] }
  )
  .refine(
    (data) => {
      const parsedPostcode = Number(data.zipCode);
      return !isNaN(parsedPostcode) && parsedPostcode > 0;
    },
    { message: 'Invalid postcode. Please enter a valid numeric postcode.', path: ['zipCode'] }
  );
